export default __webpack_public_path__ + "static/media/icon-hero.461a6370.png";